import { DashboardAndAnalysisFiltersPreview } from '@modules/analysis/components/DashboardAndAnalysisFiltersPreview';
import { WhereClausePreview } from '@modules/common/components/WhereClausePreview';
import { isEmptyWhereClause } from '@modules/common/utils';
import { CompareByFiltersPreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/CompareByFiltersPreview';
import {
  useGetQuantifyCompareQuery,
  useGetQuantifyWhereClause,
} from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';

export const WhereClauseFilterPreview = () => {
  const compareQuery = useGetQuantifyCompareQuery();
  const primaryWhereClause = useGetQuantifyWhereClause({
    shouldIncludeDashboardFilters: false,
  });
  const dashboardWhereClause = useQuantifyStore(
    ({ visual }) => visual.dashboardFilters?.whereClause,
  );

  if (compareQuery?.whereClause) {
    return <CompareByFiltersPreview />;
  }

  const renderFilterPreview = () => {
    if (dashboardWhereClause) {
      return (
        <DashboardAndAnalysisFiltersPreview
          dashboardWhereClause={dashboardWhereClause}
          analysisWhereClause={primaryWhereClause}
          analysisUseCase={AnalysisUseCase.Default}
          shouldHideHeader
        />
      );
    }

    const isWhereClausePresent =
      !!primaryWhereClause && !isEmptyWhereClause(primaryWhereClause);

    return (
      <>
        {isWhereClausePresent ? (
          <WhereClausePreview whereClause={primaryWhereClause} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No filters applied
          </Typography>
        )}
      </>
    );
  };

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle1">Filter:</Typography>
      {renderFilterPreview()}
    </Stack>
  );
};
